(() => {
  const mobileChatCSS = '@media(max-width:767px){.activator-nudge{position:fixed!important;left:auto!important;right:12px!important;bottom:calc(8px + env(safe-area-inset-bottom))!important;width:calc(50vw - 18px)!important;height:44px!important;display:flex!important;align-items:center!important;justify-content:center!important}.activator{position:relative!important;inset:auto!important;width:calc(50vw - 18px)!important;height:44px!important;min-height:44px!important;padding:8px 12px!important;border-radius:8px!important}}';
  const watched = new WeakSet();
  function configure(root) {
    if (!root) return false;
    if (!root.querySelector('#sg-mobile-chat-layout')) {
      const style = document.createElement('style');
      style.id = 'sg-mobile-chat-layout';
      style.textContent = mobileChatCSS;
      root.appendChild(style);
    }
    if (!watched.has(root)) {
      watched.add(root);
      new MutationObserver(() => configure(root)).observe(root, {childList: true, subtree: true});
    }
    const runtime = root.querySelector('shopify-agent-runtime');
    if (runtime) configure(runtime.shadowRoot);
    return Boolean(root.querySelector('.activator-nudge') || runtime?.shadowRoot?.querySelector('.activator-nudge'));
  }
  let retries = 0;
  const timer = setInterval(() => {
    const host = document.querySelector('shopify-chat');
    const ready = configure(host?.shadowRoot);
    if (ready || ++retries >= 60) clearInterval(timer);
  }, 250);
})();
